import { combineReducers } from "redux"
import user from "./user"
import adminAlert from "./adminAlert"

const reducers = combineReducers({ user, adminAlert })

export default reducers
